<div class="form-container" *ngIf="permissionData$| async as permissionData">
  <div class="tab-body">
    <div class="table-wrapper">
            <table
              mat-table
              [dataSource]="taggingDataSource"
              class="mat-elevation-z8 data-grid-table"
            >
              <ng-container *ngFor="let column of taggingColumns">
                <ng-container
                  matColumnDef="{{ column.columnDef }}"
                  *ngIf="column.columnDef == 'SourcingStatus'"
                >
                  <th mat-header-cell *matHeaderCellDef>Sourcing Status</th>
                  <td mat-cell *matCellDef="let row">
                    <ng-container class="item-row-hover" *ngIf="row.hovered && !isReady && !sourcingCompleted && (row.isEditable && isEditable || permissionData.ability.can('update',permissionData.formTagging))">
                      <a (click)="navigateToTagVendorItem(row)">
                        <div class="row-button">
                          <mat-icon title="Edit">edit</mat-icon>
                        </div>
                      </a>
                    </ng-container>
                    <ng-container class="item-row-hover" *ngIf="row.hovered && !isEditable && permissionData.ability.cannot('update', permissionData.formTagging)">
                      <a (click)="navigateToTagVendorItem(row)">
                        <div class="row-button">
                          <mat-icon title="visibility">visibility</mat-icon>
                        </div>
                      </a>
                    </ng-container>
                    {{ column.cell(row) }}
                  </td>
                </ng-container>
                <ng-container
                  matColumnDef="{{ column.columnDef }}"
                  *ngIf="column.columnDef == 'ItemNo'"
                >
                  <th mat-header-cell *matHeaderCellDef>Item No</th>
                  <td mat-cell *matCellDef="let element">
                    {{ column.cell(element) }}
                  </td>
                </ng-container>
                <ng-container
                  matColumnDef="{{ column.columnDef }}"
                  *ngIf="column.columnDef == 'ItemDescription'"
                >
                  <th mat-header-cell *matHeaderCellDef>Item Description</th>
                  <td mat-cell *matCellDef="let element">
                    {{ column.cell(element) }}
                  </td>
                </ng-container>
                <ng-container
                  matColumnDef="{{ column.columnDef }}"
                  *ngIf="column.columnDef == 'VendorsTagged'"
                >
                  <th mat-header-cell *matHeaderCellDef>Vendors Tagged</th>
                  <td mat-cell *matCellDef="let element" [tp]="column.cell(element)" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">
                    {{ column.cell(element) }}
                  </td>
                </ng-container>
                <ng-container
                  matColumnDef="{{ column.columnDef }}"
                  *ngIf="column.columnDef == 'MaterialSubGroup'"
                >
                  <th mat-header-cell *matHeaderCellDef>Material Sub Group</th>
                  <td mat-cell *matCellDef="let element">
                    {{ column.cell(element) }}
                  </td>
                </ng-container>
              </ng-container>
              
              <tr mat-header-row *matHeaderRowDef="taggingDisplayedColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: taggingDisplayedColumns"
                (mouseenter)="row.hovered = true"
                (mouseleave)="row.hovered = false"
                ></tr>
            </table>
    </div>
    <mat-paginator
      #vendorPg
      [length]="taggingDataSource.data.length"
      showFirstLastButtons
      [pageSizeOptions]="pageSizeOptions"
    ></mat-paginator>
</div>
